import { VoidCallback } from '@deqo/foundation';
import React from 'react';
import { LFC } from '../../../Legacy';
import { CommandDispatcher } from '../../../concepts/commands/CommandDispatcher';
import { Icon } from '../../../concepts/resources/Icon';
import { DropButton } from '../../../ui/DropButton';
import { useResolve } from '../../Container';
import { Copy, Flexer, Title } from '../../dashboard/elements/LayoutElements';
import { meetingBreak, meetingStop } from './MeetingCommands';

export const SetupMeetingFinishView: LFC<{ onAction: VoidCallback }> = ({ onAction }) => {

    const dispatch = useResolve(CommandDispatcher);

    const onSelect = (value: number) => {
        dispatch(meetingBreak, [value * 60000]);
    };

    return <Flexer height="100%" padding="1" gap=".5" flex="column" center>
        <Flexer gap=".5" flex="row" center >
            <Icon src="deqo://icons/meeting/finish" size="2" />
            <Title size="lg" flush>Finish Meeting</Title>
        </Flexer>
        <Flexer flex="column" center>
            <Copy flush>
                Please confirm you want to finish the meeting?
            </Copy>
        </Flexer>
        <Flexer flex="row" gap=".5" center padding=".5 0">
            <DropButton padding=".25 .75" overflow=".25" onClick={onAction}>
                <Icon src="deqo://icons/hero/arrow-sm-left" size="1.5" />
                <Title weight="450" flush>Go Back</Title>
            </DropButton>
            <DropButton id='end-meeting' data-action="editor.hostMenu.endMeeting" padding=".25 .75" overflow=".25" onClick={() => dispatch(meetingStop)}>
                <Icon src="deqo://icons/hero/check" size="1.5" />
                <Title weight="450" flush>Finish</Title>
            </DropButton>
        </Flexer>
    </Flexer>;
};
